import Logo from '../Images/Homepage/mobile-homepage.jpg';

// function modalOpen() {
//     // Get the modal
//     var modal = document.getElementById("application-modal");

//     // Get the <span> element that closes the modal
//     var span = document.getElementsByClassName("close")[0];
//     modal.style.display = "block";

//     // When the user clicks on <span> (x), close the modal
//     span.onclick = function() {
//         modal.style.display = "none";
//     }

//     // When the user clicks anywhere outside of the modal, close it
//     window.onclick = function(event) {
//         if (event.target === modal) {
//             modal.style.display = "none";
//         }
//     }
// }

function Home() {
    return(
        <div>
            {/* homepage */}
            <div>
                <div class="topbar">Luxury Recovery Housing • Safe Supportive Living • Est. 2026</div>
                <header>
                    <div class="brand">The Turn Around <span>Recovery House</span></div>
                    <nav>
                    <a href="/about">About</a>
                    <a href="/services">Services</a>
                    <a href="/contact" class="nav-btn">Contact</a>
                    </nav>
                </header>

                <main>
                    <section class="hero">
                    <div class="hero-content">
                        <div class="eyebrow">Maryland Recovery Housing</div>
                        <h1>Restore Hearts.<br/><span>Renew Hope.</span><br/>Rise Together.</h1>
                        <p class="hero-text">
                        A luxury-inspired recovery residence designed with compassion, structure, dignity, and community
                        for individuals ready for a fresh turn around.
                        </p>
                        <div class="homepage-buttons">
                            {/* <span className="btn btn-primary"><a href="/contact" className="nav-a-white">Start Your Application</a></span> */}
                            {/* <span className="btn btn-primary" onClick={() => modalOpen()}>Start Your Application</span> */}
                            <span className="btn btn-secondary"><a href="/services" className="nav-a-black">View Our Services</a></span>
                        </div>

                        <div class="luxury-stats">
                            <div class="stat"><strong>Safe</strong><small>Supportive Housing</small></div>
                            <div class="stat"><strong>Chic</strong><small>Professional Design</small></div>
                            <div class="stat"><strong>Purpose</strong><small>Growth & Stability</small></div>
                        </div>
                    </div>

                    <div class="hero-logo">
                        <img src={Logo} alt="The Turn Around Recovery House logo"/>
                    </div>
                    </section>

                    <section class="intro" id="about">
                    <div class="quote-card">
                        <h3>A refined recovery home built on dignity, healing, and hope.</h3>
                        <p>
                        We believe a peaceful, beautiful, and structured environment can support residents as they
                        rebuild confidence, restore stability, and move toward independence.
                        </p>
                    </div>

                    <div>
                        <div class="eyebrow">Our Mission</div>
                        <h2>More than a place to stay — a foundation for a new beginning.</h2>
                        <p>
                        The Turn Around Recovery House provides safe, stable, and supportive recovery housing that helps
                        residents restore hope, renew purpose, and rise together toward long-term independence.
                        </p>
                    </div>
                    </section>

                    <section class="services" id="services">
                    <div class="section-head">
                        <div class="eyebrow">Signature Support</div>
                        <h2>Professional recovery living with a luxury touch.</h2>
                        <p>Our services are designed to promote stability, confidence, accountability, and independence.</p>
                    </div>

                    <div class="service-grid">
                        <div class="service-card">
                        <div class="icon">
                            <svg viewBox="0 0 24 24"><path d="M12 21s-7-4.6-9.3-9.2C1 8.5 2.8 5 6.4 5c2 0 3.4 1.1 4.2 2.4C11.4 6.1 12.8 5 14.8 5c3.6 0 5.4 3.5 3.7 6.8C16.1 16.4 12 21 12 21Z"/></svg>
                        </div>
                        <h3>Healing Environment</h3>
                        <p>A peaceful recovery-centered setting created to support emotional wellness and stability.</p>
                        </div>

                        <div class="service-card">
                        <div class="icon">
                            <svg viewBox="0 0 24 24"><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10.5V20h13v-9.5"/><path d="M9.5 20v-6h5v6"/></svg>
                        </div>
                        <h3>Safe Housing</h3>
                        <p>Structured, supportive housing that encourages accountability, consistency, and comfort.</p>
                        </div>

                        <div class="service-card">
                        <div class="icon">
                            <svg viewBox="0 0 24 24"><path d="M12 2l1.4 5.2L18 4.4l-2.8 4.6L22 10l-6.8 1L18 15.6l-4.6-2.8L12 18l-1.4-5.2L6 15.6 8.8 11 2 10l6.8-1L6 4.4l4.6 2.8L12 2z"/></svg>
                        </div>
                        <h3>Life Skills</h3>
                        <p>Support with budgeting, employment readiness, daily routines, goals, and independence.</p>
                        </div>

                        <div class="service-card">
                        <div class="icon">
                            <svg viewBox="0 0 24 24"><path d="M12 21V9"/><path d="M12 9c-3.5 0-6-2-7-5 3.2-.4 6 .8 7 5Z"/><path d="M12 9c3.5 0 6-2 7-5-3.2-.4-6 .8-7 5Z"/><path d="M12 15c-3 0-5.2-1.5-6.5-4 3-.3 5.3.7 6.5 4Z"/><path d="M12 15c3 0 5.2-1.5 6.5-4-3-.3-5.3.7-6.5 4Z"/></svg>
                        </div>
                        <h3>New Beginnings</h3>
                        <p>Community, encouragement, purpose, growth, and the confidence to move forward.</p>
                        </div>
                    </div>
                    </section>

                    <section class="experience" id="experience">
                    <div class="section-head">
                        <div class="eyebrow">The Resident Experience</div>
                        <h2>Designed to feel safe, elevated, and empowering.</h2>
                        <p>Every detail supports comfort, confidence, and long-term recovery goals.</p>
                    </div>

                    <div class="experience-grid">
                        <div class="experience-card">
                        <h3>Structured Living</h3>
                        <p>Clear expectations, routines, and accountability help residents build consistency.</p>
                        </div>
                        <div class="experience-card">
                        <h3>Supportive Community</h3>
                        <p>Residents are encouraged through connection, peer support, and shared progress.</p>
                        </div>
                        <div class="experience-card">
                        <h3>Resource Connections</h3>
                        <p>Referrals to treatment, counseling, workforce programs, and community-based support.</p>
                        </div>
                    </div>
                    </section>

                    <section class="gallery">
                    <div class="section-head">
                        <div class="eyebrow">Brand Experience</div>
                        <h2>A professional presence for residents, families, funders, and partners.</h2>
                    </div>
                    </section>

                    <section class="pathway">
                    <div class="section-head">
                        <div class="eyebrow">How It Works</div>
                        <h2>A simple pathway to begin.</h2>
                    </div>

                    <div class="pathway-wrap">
                        <div class="step">
                        <div class="number">01</div>
                        <div>
                            <h3>Submit an Inquiry</h3>
                            <p>Complete the contact form to share your housing interest, referral, donation, or partnership request.</p>
                        </div>
                        </div>
                        <div class="step">
                        <div class="number">02</div>
                        <div>
                            <h3>Initial Follow-Up</h3>
                            <p>Our team will review your information and contact you with next steps.</p>
                        </div>
                        </div>
                        <div class="step">
                        <div class="number">03</div>
                        <div>
                            <h3>Begin Your Turn Around</h3>
                            <p>Residents enter a supportive environment focused on recovery, growth, structure, and stability.</p>
                        </div>
                        </div>
                    </div>
                    </section>

                    <section class="cta">
                        <h2>Your fresh start deserves a beautiful foundation.</h2>
                        <p>
                            Connect with The Turn Around Recovery House for housing interest, donations, partnerships,
                            referrals, or community support.
                        </p>
                        <a href="/contact" class="btn">Contact Us Today</a>
                    </section>

                    <section class="contact" id="contact">
                    <div class="section-head">
                        <div class="eyebrow">Contact & Apply</div>
                        <h2>Let's begin the conversation.</h2>
                    </div>

                    <div class="contact-layout">
                        <div class="contact-card">
                        <h3>The Turn Around Recovery House</h3>
                        <p><strong>Email:</strong> info@turnaroundrecoveryhouse.org</p>
                        <p><strong>Location:</strong> Maryland</p>
                        <p><strong>Established:</strong> 2026</p>
                        <p><strong>Message:</strong> Restore hearts. Renew hope. Rise together.</p>
                        </div>
                    </div>
                    </section>
                </main>
            </div>
            {/* Modal */}
            {/* <div id="application-modal" class="modal">
                <div class="modal-content">
                    <span class="close">&times;</span>
                    <ContactForm/>
                </div>
            </div> */}
        </div>
    )
}
export default Home;